import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, HostListener, OnDestroy, Inject, NgZone, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { URLS } from 'src/app/constants/URLS';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { AppComponent } from 'src/app/app.component';
import { DownloadProgressService } from 'src/app/_service/download-progress.service';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Subscription } from 'rxjs';
import { CategoryService } from 'src/app/_service/category.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { environment } from 'src/environments/environment';
import { getAppBasePath } from 'src/app/utils/share-link.utils';
import { getVideoThumbnail, getVideoStreamFile, getMediaId } from 'src/app/utils/media-url.utils';
import { getLanguageName, getLanguageNames } from 'src/app/utils/language.utils';
import { ShareModalComponent } from '../../sharedComponents/share-modal/share-modal.component';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { AxinomDrmService } from 'src/app/_service/axinom-drm.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { DrmCapabilityService } from 'src/app/_service/drm-capability.service';
import { TVNavigationService, Region } from 'src/app/_service/tv-navigation.service';
import { TVFocusMemoryService } from 'src/app/_service/tv-focus-memory.service';
import { AdResolverService } from 'src/app/_service/ad-resolver.service';
import { AD_CONFIG } from 'src/app/constants/ad-config';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { LoginPromptComponent } from '../../sharedComponents/login-prompt/login-prompt.component';
import { TvPurchaseRedirectService } from 'src/app/_service/tv-purchase-redirect.service';

declare let shaka: any | undefined;
declare var window: any | undefined;

@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrls: ['./video-details.component.css']
})
export class VideoDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  /** Snapshot of the component's route — see category-movie for rationale. */
  private componentRoute: string = '';
  mediaUrl:string = URLS.mediaUrl;
  imgUrl: string = URLS.imgUrl
  selectedItem: any = '';
  isVideoPlayerOpened: boolean;
  downloadingToast: boolean;
  loaderShowHide: boolean = false;
  appComponent: any;
  vidLibId: any = {};
  moreLikeThis: any[] = [];
  category: string = '';
  channelId: string = '';
  channelName: string = '';
  series_id: any = '';
  isLoading: boolean = false;
  seriesData: any = '';
  seasons: any[] = [];
  activeLowerTab: string;
  cast: any[] = [];
  crew: any[] = [];
  trailers: any[] = [];
  env: string = environment.TQR_SERVICE;
  isMobile: boolean = false;
  isTV: boolean = false;
  userId: string = '';
  private videoTimeout: any;
  private videoEventListeners: Array<{ element: HTMLElement; event: string; handler: EventListener }> = [];
  private isComponentDestroyed = false;
  selectedSeason: any;
  selectedEpisode: any;
  resumeEpisode: any = null;
  resumeSeasonNumber: number = 1;
  resumeEpisodeNumber: number = 1;
  isResuming: boolean = false;
  activeTab: any = '';
  showModal = false;
  currentTrailer: any = null;
  animateWatchlist = false;
  isLiked = false;
  animateRate: boolean = false;
  titleImageUrl: string | null = null;
  showTitleImage = false;
  persistentSupport:boolean = false;
  isIos = false;
  showFullSynopsis = false;
  @ViewChild('heroImage') heroImage: ElementRef<HTMLImageElement>;
  @ViewChild('heroVideo') heroVideo: ElementRef<HTMLVideoElement>;
  @ViewChild('muteButton') muteButton: ElementRef<HTMLButtonElement>;
  @ViewChild('muteIcon') muteIcon: ElementRef<HTMLElement>;
  @ViewChildren('actionButton') actionButtons?: QueryList<ElementRef>;
  @ViewChild('actionsContainer') actionsContainer?: ElementRef;
  @ViewChildren('episodeCard') episodeCards?: QueryList<ElementRef>;
  @ViewChild('episodesContainer') episodesContainer?: ElementRef;
  @ViewChildren('tabButton') tabButtons?: QueryList<ElementRef>;
  @ViewChild('stickyTabs') stickyTabsContainer?: ElementRef;
  @ViewChildren('seasonTab') seasonTabs?: QueryList<ElementRef>;
  @ViewChild('seasonTabsContainer') seasonTabsContainer?: ElementRef;
  @ViewChildren('castCard') castCards?: QueryList<ElementRef>;
  @ViewChild('castContainer') castContainer?: ElementRef;
  @ViewChildren('trailerCard') trailerCards?: QueryList<ElementRef>;
  @ViewChild('trailerContainer') trailerContainer?: ElementRef;
  showBannerAd = true;

  /**
   * True on a phone-width viewport. Gates the 728×90 leaderboard off mobile.
   *
   * Was a field latched once in ngOnInit, which never re-evaluated on resize:
   * a page loaded narrow and then widened kept `showNativeAd === true`, so the
   * desktop leaderboard stayed hidden at desktop width until a hard reload.
   * A getter re-reads on every change detection, and onResize() already runs one.
   */
  get showNativeAd(): boolean {
    return this.device.isMobile();
  }

  /** The ad placements below used to hardcode their key/width/height inline, so
      a key rotation in ad-config.ts silently left this page on the old creative.
      Exposed to the template so there is one place to change them. */
  readonly adConfig = AD_CONFIG;



  private trailerStartTime: number = 0;
  private shakaPlayer: any = null;
  private fpCertificate: ArrayBuffer | null = null;
  private fpKeySession: MediaKeySession | null = null;
  private visibilityObserver?: IntersectionObserver;
  private wasHidden = false;

  // TV Navigation
  private tvFocusSubscription?: Subscription;
  private episodesChangeSubscription?: Subscription;
  private readonly ACTIONS_REGION_ID = 'details-actions';
  private readonly TABS_REGION_ID = 'details-tabs';
  private readonly EPISODES_REGION_ID = 'details-episodes';
  private readonly SEASONS_REGION_ID = 'details-seasons';
  private readonly CAST_REGION_ID = 'details-cast';
  private readonly TRAILERS_REGION_ID = 'details-trailers';

  private lastScrollZone: 'hero' | 'content' | null = null;
  isActionsFocused = false;
  actionsFocusedIndex = -1;
  isEpisodesFocused = false;
  episodesFocusedIndex = -1;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private mycontentService: MycontentserviceService,
    private downloadProgressService: DownloadProgressService,
    private categService: CategoryService,
    private router: Router,
    private walletService: WalletinfoService,
    private toastrService: CustomControlsService,
    private dialog: MatDialog,
    private downloadDialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private whitelabelService: WhiteLabelService,
    private axinomService: AxinomDrmService,
    private bridgeService: IosBridgeService,
    private device: DeviceService,
    private drmCapability: DrmCapabilityService,
    private ngZone: NgZone,
    private adResolver: AdResolverService,
    private tvNav: TVNavigationService,
    private focusMemory: TVFocusMemoryService,
    private authService: AuthenticateserviceService,
    private tvPurchaseRedirect: TvPurchaseRedirectService,
  ) {
    this.axinomService.loadDrmData(this.userId);
    this.downloadProgressService.downloadCompletedEvent.subscribe((event) => {
      if (!this.isComponentDestroyed && event.success) {
        this.selectedItem.isDownloaded = true;
        this.selectedItem.offlineUri = event?.item?.offlineUri ?? null;
        this.showNotication('success', 'Download completed.'); 
      }
    });
    window.addEventListener('downloadFailed', () => {
      if (!this.isComponentDestroyed) {
        this.loaderShowHide = false;
        this.selectedItem.isDownloaded = false;
        this.downloadProgressService.resetDownloadItems();
        this.showNotication('error', 'Sorry, something went wrong during download.');
        this.cdr.detectChanges();
      }
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreen();
  }

  @HostListener('window:beforeunload')
  onBeforeUnload() {
    this.cleanupVideoPlayer();
  }

  async ngOnInit() {
    this.isIos = await this.bridgeService.isIOS();
    this.checkScreen();
    this.userId = localStorage.getItem('userId');
    this.persistentSupport = await this.drmCapability.supportsPersistentLicense();
    this.route.queryParams.subscribe(params => {
      if (params['fromPayment']) {
        console.log('💰 Returned from payment → refresh subscription');
        if (this.selectedItem?.vidLibId) {
          this.refreshSubscriptionsOnly();
        } else {
          const interval = setInterval(() => {
            if (this.selectedItem?.vidLibId) {
              clearInterval(interval);
              this.refreshSubscriptionsOnly();
            }
          }, 200);
        }
      }
    });
    this.route.params.subscribe(routeParams => {
      if (this.isComponentDestroyed) return;
      console.log('Route params changed:', routeParams);
      this.isLoading = true;
      this.cleanupVideoPlayer();
      this.selectedItem = '';
      this.seriesData = '';
      this.seasons = [];
      this.cast = [];
      this.crew = [];
      this.trailers = [];
      this.moreLikeThis = [];
      this.vidLibId = routeParams['vidLibId'];
      this.series_id = routeParams['series_id'];
      if (this.vidLibId && !this.series_id) {
        this.getSelectedVideo(this.vidLibId);
      } else if (this.series_id) {
        this.getSeriesData(this.series_id);
      }
      this.checkImageExists();
      if (this.series_id) {
        this.activeLowerTab = 'seasons';
      } else {
        this.activeLowerTab = 'morelikethis';
      }
      this.getUserLikedVideos(this.vidLibId);
    });
    this.appComponent = new AppComponent(this.downloadProgressService, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
  }

  ngOnChanges(): void {
    this.showFullSynopsis = false;
  }

  ngAfterViewInit(): void {
    this.setupTrailerVisibilityObserver();

    if (!this.device.isTV()) return;

    // This page owns its own vertical scroll (see handleTvScroll): hero
    // slides fully off-screen and the sticky tab bar pins to the top.
    // Opt out of TVNavigationService's generic scrollVerticalOnly so it
    // doesn't race our smooth scroll with a corrective scrollBy mid-transition.
    this.tvNav.skipVerticalScroll = true;

    // Wait for initial DOM to render
    setTimeout(() => {
      this.registerDetailsRegions();
    }, 100);

    // Subscribe to focus changes
    this.tvFocusSubscription = this.tvNav.focus$.subscribe(focusKey => {
      this.updateFocusState(focusKey);
      // Auto-switch tab content on focus (like Hotstar)
      this.handleTabFocusSwitch(focusKey);
      // Handle scrolling: hero ↔ tabs
      this.handleTvScroll(focusKey);

      // Save focus position for restoration when returning to this page
      if (focusKey) {
        const regionId = this.tvNav.getActiveRegionId();
        const index = this.tvNav.getFocusedIndex();
        if (regionId && regionId !== this.ACTIONS_REGION_ID) {
          this.focusMemory.saveFocusPosition({
            regionId,
            index,
            timestamp: Date.now(),
            route: this.componentRoute
          });
        }
      }
    });

    // Restore saved focus position (e.g., returning via back button)
    setTimeout(() => {
      const saved = this.focusMemory.restoreFocusPosition(this.router.url);
      if (saved) {
        this.tvNav.activateRegion(saved.regionId, saved.index);
      }
    }, 200);

    // Re-register episodes when they change (season selection)
    if (this.episodeCards) {
      this.episodesChangeSubscription = this.episodeCards.changes.subscribe(() => {
        this.registerEpisodesRegion();
      });
    }
  }

  private registerDetailsRegions(): void {
    // Register action buttons (Play, Watchlist, Like, Share)
    if (this.actionsContainer && this.actionButtons && this.actionButtons.length > 0) {
      const actionsRegion: Region = {
        id: this.ACTIONS_REGION_ID,
        type: 'banner',  // Top region, gets focus priority
        elementRef: this.actionsContainer,
        focusableItems: this.actionButtons.toArray()
      };
      this.tvNav.registerRegion(actionsRegion);
    }

    // Register sticky tab buttons (More Like This, Details, Trailers)
    if (this.stickyTabsContainer && this.tabButtons && this.tabButtons.length > 0) {
      const tabsRegion: Region = {
        id: this.TABS_REGION_ID,
        type: 'row',
        elementRef: this.stickyTabsContainer,
        focusableItems: this.tabButtons.toArray()
      };
      this.tvNav.registerRegion(tabsRegion);
    }

    // Register season tabs if present (horizontal row)
    if (this.seasonTabsContainer && this.seasonTabs && this.seasonTabs.length > 0) {
      const seasonsRegion: Region = {
        id: this.SEASONS_REGION_ID,
        type: 'row',
        elementRef: this.seasonTabsContainer,
        focusableItems: this.seasonTabs.toArray()
      };
      this.tvNav.registerRegion(seasonsRegion);
    }

    // Register episodes if present
    this.registerEpisodesRegion();

    // Register cast cards if present (horizontal row)
    if (this.castContainer && this.castCards && this.castCards.length > 0) {
      this.tvNav.unregisterRegion(this.CAST_REGION_ID);
      this.tvNav.registerRegion({
        id: this.CAST_REGION_ID,
        type: 'row',
        elementRef: this.castContainer,
        focusableItems: this.castCards.toArray()
      });
    }

    // Register trailer cards if present (horizontal row)
    if (this.trailerContainer && this.trailerCards && this.trailerCards.length > 0) {
      this.tvNav.unregisterRegion(this.TRAILERS_REGION_ID);
      this.tvNav.registerRegion({
        id: this.TRAILERS_REGION_ID,
        type: 'row',
        elementRef: this.trailerContainer,
        focusableItems: this.trailerCards.toArray()
      });
    }
  }

  private registerEpisodesRegion(): void {
    // Unregister old episodes
    this.tvNav.unregisterRegion(this.EPISODES_REGION_ID);

    // Register new episodes list if present
    if (this.episodesContainer && this.episodeCards && this.episodeCards.length > 0) {
      const episodesRegion: Region = {
        id: this.EPISODES_REGION_ID,
        type: 'form',
        elementRef: this.episodesContainer,
        focusableItems: this.episodeCards.toArray()
      };
      this.tvNav.registerRegion(episodesRegion);
    }
  }

  private updateFocusState(focusKey: string | null): void {
    // Clear all focus classes first
    this.actionButtons?.forEach(btn => btn.nativeElement.classList.remove('tv-focus'));
    this.tabButtons?.forEach(btn => btn.nativeElement.classList.remove('tv-focus'));
    this.seasonTabs?.forEach(tab => tab.nativeElement.classList.remove('tv-focus'));
    this.episodeCards?.forEach(card => card.nativeElement.classList.remove('tv-focus'));
    this.castCards?.forEach(card => card.nativeElement.classList.remove('tv-focus'));
    this.trailerCards?.forEach(card => card.nativeElement.classList.remove('tv-focus'));

    if (!focusKey) {
      this.isActionsFocused = false;
      this.actionsFocusedIndex = -1;
      this.isEpisodesFocused = false;
      this.episodesFocusedIndex = -1;
      return;
    }

    if (focusKey.startsWith(this.ACTIONS_REGION_ID + ':')) {
      this.isActionsFocused = true;
      this.actionsFocusedIndex = parseInt(focusKey.split(':')[1], 10);
      const focusedBtn = this.actionButtons?.toArray()[this.actionsFocusedIndex];
      focusedBtn?.nativeElement.classList.add('tv-focus');
    } else {
      this.isActionsFocused = false;
      this.actionsFocusedIndex = -1;
    }

    if (focusKey.startsWith(this.TABS_REGION_ID + ':')) {
      const idx = parseInt(focusKey.split(':')[1], 10);
      const focusedTab = this.tabButtons?.toArray()[idx];
      focusedTab?.nativeElement.classList.add('tv-focus');
    }

    if (focusKey.startsWith(this.SEASONS_REGION_ID + ':')) {
      const idx = parseInt(focusKey.split(':')[1], 10);
      const focusedTab = this.seasonTabs?.toArray()[idx];
      focusedTab?.nativeElement.classList.add('tv-focus');
    }

    if (focusKey.startsWith(this.EPISODES_REGION_ID + ':')) {
      this.isEpisodesFocused = true;
      this.episodesFocusedIndex = parseInt(focusKey.split(':')[1], 10);
      const focusedCard = this.episodeCards?.toArray()[this.episodesFocusedIndex];
      focusedCard?.nativeElement.classList.add('tv-focus');
    } else {
      this.isEpisodesFocused = false;
      this.episodesFocusedIndex = -1;
    }

    if (focusKey.startsWith(this.CAST_REGION_ID + ':')) {
      const idx = parseInt(focusKey.split(':')[1], 10);
      const focusedCard = this.castCards?.toArray()[idx];
      focusedCard?.nativeElement.classList.add('tv-focus');
    }

    if (focusKey.startsWith(this.TRAILERS_REGION_ID + ':')) {
      const idx = parseInt(focusKey.split(':')[1], 10);
      const focusedCard = this.trailerCards?.toArray()[idx];
      focusedCard?.nativeElement.classList.add('tv-focus');
    }
  }

  private checkScreen() {
    this.isMobile = window.innerWidth < 768;
    this.isTV = this.device.isTV();
  }

  checkImageExists() {
    let url: string;
    if (this.series_id) {
      url = `${environment.flix_thumb}SER_${this.series_id}_title_img.png`;
    } else {
      url = getVideoThumbnail(this.vidLibId, '_title_img.png');
    }
    const img = new Image();
    img.src = url;
    img.onload = () => {
      this.titleImageUrl = url;
      this.showTitleImage = true;
    };
    img.onerror = () => {
      this.titleImageUrl = null;
      this.showTitleImage = false;
    };
  }

  initializeVideoPlayer(): void {
    this.cleanupVideoPlayer();
    if (this.isComponentDestroyed) return;
    const heroImage = this.heroImage?.nativeElement;
    const heroVideo = this.heroVideo?.nativeElement;
    const muteButton = this.muteButton?.nativeElement;
    const muteIcon = this.muteIcon?.nativeElement;
    if (!heroImage || !heroVideo || !muteButton || !muteIcon) {
      console.warn('Video player elements not found');
      return;
    }
    const hasTrailer = this.selectedItem?.latest_trailer;
    heroImage.classList.add('show');
    heroVideo.classList.remove('show');
    muteButton.style.display = 'none';
    if (!hasTrailer) {
      return;
    }
    this.setupVideoElement(heroVideo);
    this.videoTimeout = setTimeout(() => {
      if (this.isComponentDestroyed) return;
      this.startVideoPlayback(heroVideo, heroImage, muteButton, muteIcon);
    }, 5000);
  }

  private async setupVideoElement(heroVideo: HTMLVideoElement): Promise<void> {
    heroVideo.muted = true;
    heroVideo.loop = false;
    heroVideo.preload = 'metadata';
    const trailers = this.selectedItem?.trailers;
    const lastTrailer = trailers?.length ? trailers[trailers.length - 1] : null;
    const trailerFile = this.getTrailerFile(lastTrailer);
    const trailerUrl = trailerFile ? `${environment.flix_video}${trailerFile}` : this.selectedItem?.latest_trailer;
    if (!trailerUrl) return;
    if (this.isAdaptiveStream(trailerUrl)) {
      if (this.isSafariApple() && trailerUrl.endsWith('.m3u8')) {
        await this.setupFairPlay(heroVideo, trailerUrl);
      } else {
        await this.setupShaka(heroVideo, trailerUrl);
      }
    } else {
      heroVideo.src = trailerUrl;
    }
    this.registerVideoEvents(heroVideo);
  }

  private async setupShaka(video: HTMLVideoElement, url: string): Promise<void> {
    if (!shaka || !shaka.Player.isBrowserSupported()) {
      console.warn('Shaka not supported, falling back to native');
      video.src = url;
      return;
    }
    if (this.shakaPlayer) {
      await this.shakaPlayer.destroy();
      this.shakaPlayer = null;
    }
    this.shakaPlayer = new shaka.Player(video);
    const licenseUrl = this.axinomService.getWidevineUrl();
    const authToken = this.axinomService.getWidevineToken();
    const persistentSupported = await this.drmCapability.supportsPersistentLicense();
    // Restore saved persistent DRM session if available
    const savedRaw = localStorage.getItem('drm_persistent_session');
    let restore = {};
    if (savedRaw) {
      try {
        const saved = JSON.parse(savedRaw);
        restore = {
          persistentSessionOnlinePlayback: true,
          persistentSessionsMetadata: [{
            sessionId: saved.sessionId,
            initData: new Uint8Array(saved.initData),
            initDataType: saved.initDataType ?? 'cenc'
          }]
        };
      } catch (e) {}
    }
    this.shakaPlayer.configure({
      drm: {
        ...restore,
        servers: {
          'com.widevine.alpha': licenseUrl
        },
        advanced: {
          'com.widevine.alpha': {
            sessionType: persistentSupported ? 'persistent-license' : 'temporary',
            persistentStateRequired: persistentSupported,
          }
        }
      },
      streaming: {
        bufferingGoal: 30,
        rebufferingGoal: 15
      }
    });
    this.shakaPlayer.getNetworkingEngine().registerRequestFilter((type, request) => {
      if (type === shaka.net.NetworkingEngine.RequestType.LICENSE && authToken) {
        request.headers['X-AxDRM-Message'] = authToken;
        request.headers['Content-Type'] = 'application/octet-stream';
      }
    });
    // Save persistent session for reuse across components
    this.shakaPlayer.addEventListener('drmsessionupdate', () => {
      const sessions = this.shakaPlayer.getActiveSessionsMetadata();
      const p = sessions.find((s: any) => s.sessionType === 'persistent-license');
      if (p) {
        localStorage.setItem('drm_persistent_session', JSON.stringify({
          sessionId: p.sessionId,
          initData: Array.from(p.initData),
          initDataType: p.initDataType
        }));
      }
    });
    try {
      await this.shakaPlayer.load(url);
    } catch (e) {
      console.error('Shaka load failed, fallback to native', e);
      video.src = url;
    }
  }

  private isSafariApple(): boolean {
    const ua = navigator.userAgent;
    const isApple = /iPad|iPhone|iPod|Macintosh/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    return isApple && isSafari;
  }

  private async setupFairPlay(video: HTMLVideoElement, url: string): Promise<void> {
    try {
      const certUrl = this.axinomService.getFairPlayCertUrl();
      const licenseUrl = this.axinomService.getFairPlayUrl();
      const token = this.axinomService.getFairplayToken();

      if (!this.fpCertificate) {
        const resp = await fetch(certUrl, { mode: 'cors' });
        if (!resp.ok) throw new Error(`Certificate fetch failed: ${resp.status}`);
        this.fpCertificate = await resp.arrayBuffer();
      }

      const onEncrypted = async (event: MediaEncryptedEvent) => {
        if (this.isComponentDestroyed) return;
        if (event.initDataType !== 'skd' || !event.initData) return;
        if (!video.mediaKeys) {
          const config: MediaKeySystemConfiguration[] = [{
            initDataTypes: ['skd'],
            videoCapabilities: [{ contentType: 'video/mp4', robustness: '' }],
            distinctiveIdentifier: 'not-allowed',
            persistentState: 'not-allowed',
            sessionTypes: ['temporary'],
          }];
          let access: MediaKeySystemAccess;
          try {
            access = await navigator.requestMediaKeySystemAccess('com.apple.fps.1_0', config);
          } catch {
            access = await navigator.requestMediaKeySystemAccess('com.apple.fps', config);
          }
          const keys = await access.createMediaKeys();
          await keys.setServerCertificate(this.fpCertificate!);
          await video.setMediaKeys(keys);
        }
        if (!this.fpKeySession) {
          this.fpKeySession = video.mediaKeys!.createSession('temporary');
          this.fpKeySession.addEventListener('message', async (msgEvt: any) => {
            try {
              const resp = await fetch(licenseUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/octet-stream',
                  'X-AxDRM-Message': token,
                },
                body: msgEvt.message,
              });
              if (!resp.ok) throw new Error(`License failed: ${resp.status}`);
              const ckc = await resp.arrayBuffer();
              await this.fpKeySession!.update(ckc);
            } catch (e) {
              console.error('FairPlay license error:', e);
            }
          });
        }
        const data = new Uint8Array(event.initData);
        let str = '';
        for (let i = 0; i < data.length; i++) {
          if (data[i] === 0) continue;
          str += String.fromCharCode(data[i]);
        }
        const skdIndex = str.indexOf('skd://');
        if (skdIndex === -1) throw new Error('No skd:// in initData');
        const tail = str.substring(skdIndex);
        const end = tail.search(/[\s'"]/);
        const skdUri = end === -1 ? tail.trim() : tail.substring(0, end).trim();
        await this.fpKeySession.generateRequest('skd', new TextEncoder().encode(skdUri).buffer);
      };

      this.addEventListenerWithCleanup(video, 'encrypted', onEncrypted as any);
      video.src = url;
      video.load();
      console.log('FairPlay trailer setup complete');
    } catch (e) {
      console.error('FairPlay setup failed, fallback to native:', e);
      video.src = url;
    }
  }

  private registerVideoEvents(heroVideo: HTMLVideoElement): void {
    this.addEventListenerWithCleanup(heroVideo, 'ended', () => {
      if (!this.isComponentDestroyed) {
        this.stopVideo(heroVideo, this.heroImage.nativeElement, this.muteButton.nativeElement);
      }
    });
    this.addEventListenerWithCleanup(heroVideo, 'error', (e) => {
      console.error('Video error:', e);
      if (!this.isComponentDestroyed) {
        this.stopVideo(heroVideo, this.heroImage.nativeElement, this.muteButton.nativeElement);
      }
    });
  }
  
  private startVideoPlayback(heroVideo: HTMLVideoElement, heroImage: HTMLElement, muteButton: HTMLElement, muteIcon: HTMLElement): void {
    if (this.isComponentDestroyed) return;
    const playPromise = heroVideo.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log('Video playing successfully');
          this.trailerStartTime = Date.now();
          const checkVideoReady = () => {
            if (this.isComponentDestroyed) return;
            if (heroVideo.readyState >= 3 || heroVideo.buffered.length > 0) {
              heroImage.classList.remove('show');
              heroVideo.classList.add('show');
              muteButton.style.display = 'block';
            } else {
              setTimeout(checkVideoReady, 100);
            }
          };
          checkVideoReady();
        })
        .catch(error => {
          console.error('Error playing video:', error);
          this.stopVideo(heroVideo, heroImage, muteButton);
        });
    }
    const muteButtonHandler = () => {
      if (!this.isComponentDestroyed) {
        heroVideo.muted = !heroVideo.muted;
        muteIcon.className = heroVideo.muted ? 'fa fa-volume-mute' : 'fa fa-volume-up';
      }
    };
    this.addEventListenerWithCleanup(muteButton, 'click', muteButtonHandler);
  }

  private addEventListenerWithCleanup(element: HTMLElement, event: string, handler: EventListener): void {
    element.addEventListener(event, handler);
    this.videoEventListeners.push({ element, event, handler });
  }

  stopVideo(video: HTMLVideoElement, image: HTMLElement, muteBtn: HTMLElement): void {
    if (this.isComponentDestroyed) return;
    try {
      image.classList.add('show');
      video.classList.remove('show');
      muteBtn.style.display = 'none';
      if (video && !video.paused) {
        video.pause();
      }
      if (video) {
        video.currentTime = 0;
      }
      if (this.videoTimeout) {
        clearTimeout(this.videoTimeout);
        this.videoTimeout = null;
      }
    } catch (error) {
      console.error('Error stopping video:', error);
    }
  }

  private cleanupVideoPlayer(): void {
    this.updateTrailerWatchHistory();
    try {
      if (this.videoTimeout) {
        clearTimeout(this.videoTimeout);
        this.videoTimeout = null;
      }
      this.videoEventListeners.forEach(({ element, event, handler }) => {
        try {
          element.removeEventListener(event, handler);
        } catch (error) {
          console.error('Error removing event listener:', error);
        }
      });
      this.videoEventListeners = [];
      if (this.heroVideo?.nativeElement) {
        const video = this.heroVideo.nativeElement;
        try {
          if (!video.paused) {
            video.pause();
          }
          video.currentTime = 0;
          video.removeAttribute('src');
          video.load(); 
        } catch (error) {
          console.error('Error cleaning up video element:', error);
        }
      }
      if (this.heroImage?.nativeElement) {
        this.heroImage.nativeElement.classList.add('show');
      }
      if (this.heroVideo?.nativeElement) {
        this.heroVideo.nativeElement.classList.remove('show');
      }
      if (this.muteButton?.nativeElement) {
        this.muteButton.nativeElement.style.display = 'none';
      }
      if (this.shakaPlayer) {
        try {
          this.shakaPlayer.destroy();
        } catch (e) {
          console.warn('Shaka destroy failed', e);
        }
        this.shakaPlayer = null;
      }
      if (this.fpKeySession) {
        try {
          this.fpKeySession.close();
        } catch (e) {
          console.warn('FairPlay session close failed', e);
        }
        this.fpKeySession = null;
      }
    } catch (error) {
      console.error('Error during video cleanup:', error);
    }
  }

  private updateTrailerWatchHistory(): void {
    if (this.trailerStartTime <= 0) return;
    const userId = localStorage.getItem('userId');
    if (!userId || !this.selectedItem?.vidLibId) return;
    const video = this.heroVideo?.nativeElement;
    const secondsWatched = Math.round((Date.now() - this.trailerStartTime) / 1000);
    this.trailerStartTime = 0;
    if (secondsWatched <= 0) return;
    const now = new Date();
    const createdOn = `${now.getDate()}-${now.toLocaleString('default', { month: 'short' })}-${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
    const requestBody: any = {
      "channel": this.selectedItem?.channelId,
      "isDrmVideo": "1",
      "playBackMode": "server",
      "playState": "2",
      "secondsWatched": `${secondsWatched}`,
      "currentPlaybackPosition": `${video?.currentTime || 0}`,
      "subtitleLanguage": "Stereo, 0.13 Mbps",
      "videoDuration": `${video?.duration || 0}`,
      "videoFileSIze": `${this.selectedItem?.videoFileSize || 0}`,
      "videoId": this.selectedItem.vidLibId,
      "videoType": this.selectedItem?.videoType,
      "createdOn": createdOn,
      "eventId": "13",
      "eventType": "13",
      "userId": userId,
      "platformType": this.device.getPlatformType(),
      "trailerTitle": this.selectedItem?.title,
      "contentType": "TRAILER"
    };
    this.mycontentService.updateUserVideoTracking(requestBody).subscribe({
      next: () => console.log('Video details trailer watch history updated:', secondsWatched, 's'),
      error: (err) => console.error('Error updating video details trailer watch history:', err)
    });
  }

  private setupTrailerVisibilityObserver(): void {
    const el = this.heroVideo?.nativeElement || this.heroImage?.nativeElement;
    if (el) {
      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting && this.trailerStartTime > 0) {
            this.stopAndCleanupTrailer();
          }
        },
        { threshold: 0.3 }
      );
      this.visibilityObserver.observe(el);
    }
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange(): void {
    if (document.hidden && this.trailerStartTime > 0) {
      this.wasHidden = true;
      this.stopAndCleanupTrailer();
    }
  }

  private stopAndCleanupTrailer(): void {
    const video = this.heroVideo?.nativeElement;
    if (video && !video.paused) {
      video.pause();
    }
    this.cleanupVideoPlayer();
  }

  isAdaptiveStream(url: string): boolean {
    return url?.endsWith('.m3u8') || url?.endsWith('.mpd');
  }
  
  ngOnDestroy(): void {
    // Save TV focus position for restoration when returning
    if (this.device.isTV()) {
      const regionId = this.tvNav.getActiveRegionId();
      const index = this.tvNav.getFocusedIndex();
      if (regionId && regionId !== this.ACTIONS_REGION_ID) {
        this.focusMemory.saveFocusPosition({
          regionId,
          index,
          timestamp: Date.now(),
          route: this.componentRoute
        });
      }

      this.tvNav.unregisterRegion(this.ACTIONS_REGION_ID);
      this.tvNav.unregisterRegion(this.TABS_REGION_ID);
      this.tvNav.unregisterRegion(this.SEASONS_REGION_ID);
      this.tvNav.unregisterRegion(this.EPISODES_REGION_ID);
      this.tvNav.unregisterRegion(this.CAST_REGION_ID);
      this.tvNav.unregisterRegion(this.TRAILERS_REGION_ID);
      // Re-enable generic vertical scroll for the next page.
      this.tvNav.skipVerticalScroll = false;
    }
    this.tvFocusSubscription?.unsubscribe();
    this.episodesChangeSubscription?.unsubscribe();

    this.isComponentDestroyed = true;
    this.visibilityObserver?.disconnect();
    this.cleanupVideoPlayer();
  }

  onSeasonChange(seasonId: number) {
    if (this.seriesData) {
      this.selectedSeason = this.seasons.find(season => season.seasonId == seasonId);
      this.activeTab = seasonId;
    }
  }

  getPropertyValue(video: any, name: string): string | undefined {
    const prop = video.tqrVideoBean.properties.find((prop: any) => prop.name === name);
    return prop ? prop.value : undefined;
  }

  getPropertyValue1(video: any, name: string): string | undefined {
    const prop = video.properties.find((prop: any) => prop.name === name);
    return prop ? prop.value : undefined;
  }

  async getSelectedVideo(vidLibId: any) {
    this.isLoading = true;
    try {
      const [videoResult, isWatched, subscriptions, watchHistory] = await forkJoin([
        this.categService.getPrimeVideo(vidLibId),
        this.mycontentService.isInWatchlist(vidLibId),
        this.walletService.getUserSubscriptions(),
        this.mycontentService.getContinueWatching()
      ]).toPromise();
      if (this.isComponentDestroyed) return;
      const transformedData = this.mycontentService.transformVideoData(videoResult?.data[0], 'Prime');
      try {
        if(this.bridgeService.isIOS()){
          const downloadedVideo = await this.isDownloadFileExistInIos(vidLibId);
          transformedData.isDownloaded = downloadedVideo;
        }else{
          const downloadedVideo = await this.isDownloadFileExist(this.mediaUrl + getVideoStreamFile(transformedData));
          transformedData.isDownloaded = downloadedVideo;
          if(transformedData.isDownloaded){
            const data = await this.getOfflineUri(this.mediaUrl + getVideoStreamFile(transformedData));
            transformedData.offlineUri = data?.offlineUri || null;
          }else{
            transformedData.offlineUri = null;
          }
        }
      } catch (error) {
        console.error('Failed to check download status:', error);
        transformedData.isDownloaded = false;
        transformedData.offlineUri = null;
      }
      this.selectedItem = transformedData;
      this.channelName = this.selectedItem?.channel_desc;
      this.cast = [
        ...this.selectedItem?.crew?.map((item: any) => ({ ...item, roleType: 'crew' })),
        ...this.selectedItem?.cast?.map((item: any) => ({ ...item, roleType: 'cast' }))
      ];
      this.trailers = this.selectedItem?.trailers?.map((trailer: any) => ({
        thumbnail: getVideoThumbnail(this.selectedItem, '_thumb_b.jpg'),
        ...trailer
      }));
      this.selectedItem.isWatched = isWatched;
      subscriptions.forEach((sitem: any) => {
        if (this.selectedItem.channelId == sitem.channelId && sitem.isActive) {
          this.selectedItem.isChannelSubscribed = true;
          this.selectedItem.expiringDate = sitem.dateOfExpiry;
        }
        if (this.selectedItem.vidLibId == sitem.vidLibId && sitem.isActive) {
          this.selectedItem.isPPVSubscribed = true;
          this.selectedItem.expiringDate = sitem.dateOfExpiry;
        }else if(this.selectedItem.channelId == sitem.channelId && sitem.isActive && this.selectedItem.ppv_subscribed === '0'){
          this.selectedItem.isPPVSubscribed = true;
          this.selectedItem.expiringDate = sitem.dateOfExpiry;
        }
      });
      const whitem = watchHistory?.find(w => w.vidLibId == this.selectedItem.vidLibId);
      if (whitem) {
        this.selectedItem.watchedPercentage = whitem.watchedPercentage;
        this.selectedItem.secondsWatched = (whitem.lastPositionMs)/1000;
      }
      this.getMoreLikeVideos(this.selectedItem?.channelId);
      this.isLoading = false;
      this.cdr.detectChanges();
      this.initializeVideoPlayer();
      console.log(this.selectedItem);

      // Re-register TV navigation regions after data loads
      if (this.device.isTV()) {
        setTimeout(() => this.registerDetailsRegions(), 100);
      }
    } catch (error) {
      this.isLoading = false;
      console.error('Error fetching video details:', error);
      this.cdr.detectChanges(); 
    }
  }

  getSeriesData(seriesId: number) {
    this.isLoading = true;
    this.http.post(`${URLS.getEpisodicConent}?series_id=${seriesId}`, {}).subscribe((result: any) => {
      if (this.isComponentDestroyed) return;
      this.seriesData = result.data;
      this.seriesData.cpGenres = (this.seriesData.cpGenres)?.split(',');
      this.cast = [
        ...result.data.seriesCasts?.map((item: any) => ({ ...item, roleType: 'cast' })),
        ...result.data.seriesCrews?.map((item: any) => ({ ...item, roleType: 'crew' }))
      ];
      this.seasons = result.data.seasons;
      this.selectedItem = this.seasons[0];
      this.trailers = this.seriesData.seriesFiles?.filter(file => file.file_type_id === '7') || [];
      const latestTrailer = this.trailers.length > 0 ? this.trailers[this.trailers.length - 1].file_Location : null;
      const titleImageFiles = this.seriesData.seriesFiles?.filter(file => file.file_type_id === '8') || [];
      const latestTitleImage = titleImageFiles.length > 0 ? titleImageFiles[titleImageFiles.length - 1].file_Location : null;
      this.loadTrailerThumbnails();
      const latestTrailerObj = this.trailers.length > 0 ? this.trailers[this.trailers.length - 1] : null;
      const latestTrailerUrl = latestTrailerObj?.mpdManifest || latestTrailerObj?.hlsManifest
        ? `${environment.flix_video}${this.getTrailerFile(latestTrailerObj)}`
        : latestTrailer ? `${this.env}cms/ContentController/file/${latestTrailer}` : null;
      this.selectedItem = {
        ...this.selectedItem,
        latest_trailer: latestTrailerUrl,
        trailers: this.trailers,
        title_img: latestTitleImage
      };
      this.seasons = this.seasons.map((season: any) => {
        return {
          ...season,
          episodes: season.episodes.map((episode: any) => {
            return {
              ...episode,
              tqrVideoBean: this.mycontentService.transformVideoData(episode.tqrVideoBean, 'Prime')
            };
          })
        };
      });
      const presentSelectedSeasonId = this.selectedItem.seasonId;
      const presentSelectedEpisodeNumber = this.selectedItem.episodes[0].episodeId;
      if (presentSelectedSeasonId) {
        this.selectedSeason = this.seasons.find((season: any) => season.seasonId == presentSelectedSeasonId);
        this.selectedEpisode = this.selectedSeason.episodes.find((episode) => episode.episodeNumber == presentSelectedEpisodeNumber);
        this.activeTab = this.selectedSeason.seasonId;
      }
      // Merge first episode's video data into selectedItem so button conditions work
      const firstEpisodeData = this.seasons[0]?.episodes?.[0]?.tqrVideoBean;
      if (firstEpisodeData) {
        this.selectedItem = {
          ...this.selectedItem,
          preparedVideoType: firstEpisodeData.preparedVideoType,
          channelId: firstEpisodeData.channelId,
          ppv_subscribed: firstEpisodeData.ppv_subscribed,
          ppv_unsubscribed: firstEpisodeData.ppv_unsubscribed,
          currencySymbol: firstEpisodeData.currencySymbol,
        };
      }

      this.isLoading = false;
      this.cdr.detectChanges();
      this.initializeVideoPlayer();

      // Fetch subscriptions + watch history for series buttons
      forkJoin([
        this.walletService.getUserSubscriptions(),
        this.mycontentService.getContinueWatching()
      ]).subscribe(([subscriptions, watchHistory]: [any[], any[]]) => {
        subscriptions?.forEach((sitem: any) => {
          if (this.selectedItem.channelId == sitem.channelId && sitem.isActive) {
            this.selectedItem.isChannelSubscribed = true;
            this.selectedItem.expiringDate = sitem.dateOfExpiry;
          }
        });
        this.findResumeEpisode(watchHistory || []);
        // Map watchedPercentage to episode seek bars
        watchHistory?.forEach((w: any) => {
          this.seasons.forEach((season: any) => {
            season.episodes?.forEach((ep: any) => {
              if (ep.tqrVideoBean?.vidLibId == w.vidLibId) {
                ep.watchedPercentage = w.watchedPercentage;
              }
            });
          });
        });
        this.cdr.detectChanges();
      }, () => {
        this.setDefaultResumeEpisode();
      });

      // Re-register TV navigation regions after data loads
      if (this.device.isTV()) {
        setTimeout(() => this.registerDetailsRegions(), 100);
      }
    }, (error) => {
      this.isLoading = false;
    });
  }

  findResumeEpisode(watchHistory: any[]): void {
    if (!this.seasons?.length || !watchHistory?.length) {
      this.setDefaultResumeEpisode();
      return;
    }
    for (const season of this.seasons) {
      for (const episode of (season.episodes || [])) {
        const vidLibId = episode.tqrVideoBean?.vidLibId;
        const match = watchHistory.find(w => w.vidLibId == vidLibId);
        if (match && match.watchedPercentage > 0 && match.watchedPercentage < 95) {
          this.resumeEpisode = episode;
          this.resumeSeasonNumber = episode.tqrVideoBean?.season_number || season.seasonNumber;
          this.resumeEpisodeNumber = episode.tqrVideoBean?.episode_number || 1;
          this.isResuming = true;
          episode.tqrVideoBean.watchedPercentage = match.watchedPercentage;
          episode.tqrVideoBean.secondsWatched = (match.lastPositionMs) / 1000;
          return;
        }
      }
    }
    this.setDefaultResumeEpisode();
  }

  private setDefaultResumeEpisode(): void {
    const firstSeason = this.seasons[0];
    const firstEpisode = firstSeason?.episodes?.[0];
    this.resumeEpisode = firstEpisode || null;
    this.resumeSeasonNumber = firstSeason?.seasonNumber || 1;
    this.resumeEpisodeNumber = firstEpisode?.tqrVideoBean?.episode_number || 1;
    this.isResuming = false;
  }

  playResumeEpisode(): void {
    if (this.isGuestUser) {
      this.showLoginPrompt('Login or Create a Free Account to start watching');
      return;
    }
    if (this.resumeEpisode) {
      this.openPlayerView(this.resumeEpisode);
    }
  }

  getMoreLikeVideos(channelId: any) {
    this.isLoading = true;
    const category = localStorage.getItem('category');
    const usrId = localStorage.getItem("userId");
    forkJoin({
      moreLike: this.categService.sectionsByCategoryAndChannelId(category, '0', '10'),
      watchlist: this.mycontentService.getWatchListOfUser(usrId),
      subscriptions: this.walletService.getUserSubscriptions()
    }).subscribe(
      ({ moreLike, watchlist, subscriptions }) => {
        if (this.isComponentDestroyed) return;
        moreLike?.forEach(item => this.mycontentService.transformData(item));
        this.moreLikeThis = moreLike.filter(i => i.vidLibId != this.vidLibId);
        this.mapMoreLikeWatchContent(watchlist);
        this.mapMoreLikeSubscription(subscriptions);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  mapMoreLikeWatchContent(watchresult: any[]) {
    if (!this.moreLikeThis?.length) return;
    this.moreLikeThis.forEach(section => {
      section.isInWatchList = false;
      watchresult?.forEach(wlitem => {
        if (section.vidLibId == wlitem.vidLibId) {
          section.isInWatchList = true;
        }
      });
    });
  }
  
  mapMoreLikeSubscription(subscriptions: any[]) {
    if (!this.moreLikeThis?.length) return;
    this.moreLikeThis.forEach(section => {
      section.isChannelSubscribed = false;
      section.isPPVSubscribed = false;
      subscriptions?.forEach(sitem => {
        if (section.channelId == sitem.channelId && sitem.isActive) {
          section.isChannelSubscribed = true;
          section.expiringDate = sitem.dateOfExpiry;
        }
        if ((section.vidLibId == sitem.contentId || section.vidLibId == sitem.vidLibId) && sitem.isActive) {
          section.isPPVSubscribed = true;
          section.expiringDate = sitem.dateOfExpiry;
        } else if (section.channelId == sitem.channelId && sitem.isActive && section.sub_value === '0') {
          section.isPPVSubscribed = true;
          section.expiringDate = sitem.dateOfExpiry;
        }
      });
    });
  }

  handleWatchList(selectedItem) {
    if (this.isGuestUser) {
      this.showLoginPrompt('Login or Create a Free Account to save to your watchlist');
      return;
    }
    this.animateWatchlist = true;
    if (selectedItem.isWatched) {
      this.removeFromWatchList(selectedItem.vidLibId);
    } else {
      this.addInWatchList(selectedItem.vidLibId);
    }
  }

  addInWatchList(vidLibId) {
    const userId = localStorage.getItem("userId");
    this.mycontentService.addInWatchList(userId, vidLibId).subscribe(result => {
      if (this.isComponentDestroyed) return;
      if (result.status == 0) {
        this.animateWatchlist = false;
        this.selectedItem.isWatched = true;
        this.showNotication('success', 'successfully added to the watchlist..');
      } else if (result.status == 1) {
        this.animateWatchlist = false;
        this.showNotication("warning", "unable to add please try again..");
      }
    }, (error) => {
      this.animateWatchlist = false;
    });
  }

  removeFromWatchList(vidLibId) {
    const userId = localStorage.getItem("userId");
    this.mycontentService.removeFromWatchList(userId, vidLibId).subscribe(result => {
      if (this.isComponentDestroyed) return;
      if (result.status == 0) {
        this.animateWatchlist = false;
        this.selectedItem.isWatched = false;
        this.showNotication('success', "successfully removed from the watchlist..");
      } else if (result.status == 1) {
        this.showNotication("warning", "unable to remove please try again..");
        this.animateWatchlist = false;
      }
    }, (error) => {
      this.animateWatchlist = false;
    });
  }

  async downloadFile(fileName: string, videoId: number, title: string) {
    if (this.isGuestUser) {
      this.showLoginPrompt('Login or Create a Free Account to download videos');
      return;
    }
    const win = window as any;
    console.log('clicked on downlaod button');
    if (win.webkit?.messageHandlers?.downloadHandler) {
      const payload = {
        video: this.selectedItem,
        videoId
      };
      win.webkit.messageHandlers.downloadHandler.postMessage(payload);
      this.downloadProgressService.resetDownloadItems();
      this.downloadProgressService.currentDownloadVideoId = String(videoId);
      this.downloadProgressService.isDownloadInprogress = true;
      console.log('sent data while download button clicked', payload);
      return;
    }
    if (this.downloadProgressService.clickLocked) return;
    this.downloadProgressService.clickLocked = true;
    this.loaderShowHide = true;
    const manifestUri = this.mediaUrl + fileName;
    if (this.downloadProgressService.isDownloadInprogress) {
      this.showNotication('info', 'Another download is in progress. Please wait.');
      this.downloadProgressService.clickLocked = false;
      this.loaderShowHide = true;
      return;
    }
    if (this.selectedItem?.isDownloaded) {
      this.showNotication('info', 'This video is already downloaded.');
      this.downloadProgressService.clickLocked = false;
      this.loaderShowHide = false;
      return;
    }
    const exists = await this.isDownloadFileExist(manifestUri);
    console.log(exists);
    if (exists) {
      this.showNotication('info', 'Already downloaded.');
      this.downloadProgressService.clickLocked = false;
      this.loaderShowHide = false;
      return;
    }
    console.log("📄 Reading MPD:", manifestUri);
    const mpdText = await (await fetch(manifestUri)).text();
    const xmlMPD = new DOMParser().parseFromString(mpdText, "application/xml");
    let qualities = [];
    xmlMPD.querySelectorAll("AdaptationSet[contentType='video']").forEach(set => {
      const defaultHeight = set.getAttribute("height"); 
      set.querySelectorAll("Representation").forEach(rep => {
        const height = rep.getAttribute("height") || defaultHeight; 
        const file = rep.querySelector("BaseURL")?.textContent.trim();
        qualities.push({
            label: height ? `${height}p` : "Auto",
            height: height ? +height : null,
            url: this.mediaUrl + file,
            sizeMB: null,
            time: null
        });
      });
    });
    async function getFileSize(url: string): Promise<string> {
      try {
        const res = await fetch(url,{method:"HEAD"});
        const bytes = +res.headers.get("Content-Length");
        return (bytes/1024/1024).toFixed(2); 
      } catch { return "Unknown"; }
    }
    for(let q of qualities){
      q.sizeMB = await getFileSize(q.url);
    }
    async function getSpeedMbps(testUrl: string): Promise<number> {
      try {
        const start = performance.now();
        const response = await fetch(testUrl, {
          method: "GET",
          headers: { Range: "bytes=0-999999" } 
        });
        const buffer = await response.arrayBuffer();
        const seconds = (performance.now() - start) / 1000;
        return ((buffer.byteLength * 8) / 1024 / 1024 / seconds); 
      } catch {
        return 0;
      }
    }    
    const speed = await getSpeedMbps(qualities[0].url);
    console.log("⚡ Speed:",speed.toFixed(2),"Mbps");
    qualities = qualities.map(q => ({
      ...q,
      speed: speed.toFixed(2),
      time: (speed && !isNaN(+q.sizeMB)) ? `${Math.round((+q.sizeMB * 8) / speed)} sec` : '--'
    }));
    const dialogRef = this.downloadDialog.open(DownloadQualityDialogComponent, {
      panelClass: 'download-dialog',
      data: { qualities: qualities }
    });
    dialogRef.afterClosed().subscribe(async (selectedQuality) => {
      this.downloadProgressService.clickLocked = false;
      this.loaderShowHide = false;
      if (!selectedQuality) {
        console.log("User cancelled");
        return;
      }
      console.log("✔ Selected quality:", selectedQuality);
      this.downloadProgressService.resetDownloadItems();
      this.loaderShowHide = false;
      this.downloadProgressService.currentDownloadVideoId = String(videoId);
      this.downloadProgressService.isDownloadInprogress = true;
      await this.downloadContent(manifestUri, title, selectedQuality);
    });
  }

  async downloadContent(manifestUri: string, title: string, selectedQuality: string) {
    let thumbnailBlob: Blob | null = null;
    try {
      const thumbnailUrl = manifestUri.replace('drm_meta.mpd', 'thumb.jpg');
      thumbnailBlob = await this.downloadProgressService.fetchThumbnailBlob(thumbnailUrl);
    } catch (e) {
      console.warn('[Download] thumbnail fetch failed:', e);
    }
    const metadata = {
      title,
      downloaded: new Date(),
      selectedQuality,
      fileSize: this.selectedItem?.videoFileSize,
      thumbnail: thumbnailBlob ?? null,
      ...this.selectedItem
    };
    window.storage.configure({
      offline: {
        trackSelectionCallback: (tracks) => {
          const variants = tracks.filter(t => t.type === "variant");
          const audio = tracks.filter(t => t.type === "audio");
          const textTracks = tracks.filter(t => t.type === "text");
          console.log("Variants:", variants);
          console.log("Texts:", textTracks);
          const selectedHeight = parseInt(selectedQuality);
          let selectedVariant = variants.find(v => v.height === selectedHeight);
          if (!selectedVariant) {
            selectedVariant = variants.sort(
              (a, b) => Math.abs(a.height - selectedHeight) - Math.abs(b.height - selectedHeight)
            )[0];
          }
          console.log("Selected video:", selectedVariant);
          console.log("Audio languages downloading:", audio.map(a => a.language));
          console.log("Subtitles downloading:", textTracks.map(t => t.language));    
          console.log("Selected variant:", selectedVariant);
          return [
            selectedVariant,
            ...audio,
            ...textTracks
          ];
        }
      }
    });
    const maxAttempts = 5;
    let attempt = 0;
    while (attempt < maxAttempts) {
      try {
        console.log(`📥 Download attempt ${attempt + 1}/${maxAttempts}`);
        const stored = await window.storage.store(manifestUri, metadata);
        stored.isCompleted = true;
        this.downloadProgressService.completeStatusSent = false;
        this.downloadProgressService.prepareDownloadData({ detail: stored });
        console.log("✅ Download completed:", stored);
        return;
      } catch (err: any) {
        attempt++;
        console.error(`❌ Download attempt ${attempt} failed`, err);
        if (err?.name === 'QuotaExceededError') {
          this.showNotication('error', 'Not enough storage space.');
          break;
        }
        if (attempt >= maxAttempts) {
          this.showNotication('error', 'Download failed after retries.');
          break;
        }
        await new Promise(res => setTimeout(res, 500 * attempt));
      }
    }
    this.downloadProgressService.resetDownloadItems();
    this.loaderShowHide = false;
    this.showNotication('error', 'Download failed.');
  }

  onDownloadClick(manifestUri: string, title: string, selectedQuality) {
    this.appComponent.setDownloadProgress(null, 0);
    this.downloadContent(manifestUri, title, selectedQuality);
  }

  updateOnlineStatus() {
    const signal = document.getElementById('online-signal');
    if (navigator.onLine) {
      signal.innerHTML = 'ONLINE';
      signal.style.background = 'green';
    } else {
      signal.innerHTML = 'OFFLINE';
      signal.style.background = 'grey';
    }
  }

  listContent() {
    return window.storage?.list();
  }

  async isDownloadFileExist(originalManifestUri: string): Promise<boolean | null> {
    if (!(window as any).storage) return null;
    try {
      const list = await window.storage.list();
      return (list || []).some(v =>
        v.originalManifestUri?.includes(originalManifestUri) && !!v.offlineUri 
      );
    } catch (e) {
      console.error('Error checking downloaded file:', e);
      return null;
    }
  }

  async isDownloadFileExistInIos(vidLibId): Promise<boolean> {
    return new Promise(resolve => {
      this.bridgeService.requestDownloadList();
      const listener = (event: any) => {
        const list = event?.detail ?? [];
        window.removeEventListener("nativeDownloadsLoaded", listener);
        resolve(list.some(v => v.videoId == vidLibId));
      };
      window.addEventListener("nativeDownloadsLoaded", listener);
      setTimeout(() => resolve(false), 3000);
    });
  }

  async getOfflineUri(originalManifestUri: string): Promise<any | null> {
    if (!(window as any).storage) return null;
    try {
      const list = await window.storage.list();
      for (const v of list || []) {
        if (v.originalManifestUri?.includes(originalManifestUri) && !!v.offlineUri) { 
          return v;
        }
      }
      return null;
    } catch (e) {
      console.error('Error fetching offline uri:', e);
      return null;
    }
  }

  showNotication(type: any, message: any) {
    this.toastrService.showNotification(
      type,
      '',
      message,
      3000
    );
  }

  @ViewChild('modalVideo') modalVideo!: ElementRef<HTMLVideoElement>;
  private modalShakaPlayer: any = null;

  getTrailerFile(trailer: any | null): string | null{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || !!(window as any)?.webkit;
    if(isSafari){
      return trailer?.hlsManifest || trailer?.mpdManifest || this.extractFileName(this.selectedItem.latest_trailer);
    }else{
      return trailer?.mpdManifest || trailer?.hlsManifest || this.extractFileName(this.selectedItem.latest_trailer);
    }
  }
  extractFileName(url: string): string {
    return new URL(url).pathname.split('/').pop() ?? '';
  }

  openTrailerModal(trailer: any) {
    console.log(this.seriesData);
    console.log(trailer);
    console.log(this.selectedItem);
    if(this.seriesData?.serieId){
      const trailerFile = this.getTrailerFile(trailer) || this.extractFileName(trailer.url);
      const route = this.whitelabelService.getPrefixedRoute('trailer', trailer.title, trailerFile, this.selectedItem?.episodes[0]?.tqrVideoBean?.vidLibId, 'watch');
      this.router.navigate([route]);
      console.log(route)
    }else{
      const route = this.whitelabelService.getPrefixedRoute('trailer', trailer.title, this.getTrailerFile(trailer), this.selectedItem?.vidLibId, 'watch');
      this.router.navigate([route]);
      console.log(route)
    }
    // this.currentTrailer = trailer;
    // this.showModal = true;
    // this.cleanupVideoPlayer();
    // setTimeout(() => {
    //   const video = this.modalVideo?.nativeElement;
    //   if (!video) return;
    //   video.muted = true;
    //   video.autoplay = true;
    //   video.playsInline = true;
    //   const url = trailer?.url || trailer?.latest_trailer;
    //   if (this.isAdaptiveStream(url)) {
    //     this.initModalShaka(video, url);
    //   }
    //   else {
    //     video.src = url;
    //     video.play().catch(err => {
    //       console.warn('Modal trailer autoplay failed', err);
    //     });
    //   }
    // });
  }
  
  private async initModalShaka(video: HTMLVideoElement, manifestUrl: string) {
    try {
      shaka.polyfill.installAll();
      if (!shaka.Player.isBrowserSupported()) {
        console.warn('Shaka not supported, falling back to native');
        video.src = manifestUrl;
        await video.play();
        return;
      }
      this.modalShakaPlayer = new shaka.Player(video);
      this.modalShakaPlayer.addEventListener('error', (e: any) => {
        console.error('Modal Shaka error', e);
        this.onClose();
      });
      await this.modalShakaPlayer.load(manifestUrl);
      await video.play();
    } catch (err) {
      console.error('Modal Shaka init failed', err);
      this.onClose();
    }
  }
  
  onClose() {
    this.showModal = false;
    if (this.modalShakaPlayer) {
      this.modalShakaPlayer.destroy();
      this.modalShakaPlayer = null;
    }
    if (this.modalVideo?.nativeElement) {
      const video = this.modalVideo.nativeElement;
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    this.currentTrailer = null;
    setTimeout(() => {
      if (!this.isComponentDestroyed) {
        this.initializeVideoPlayer();
      }
    }, 100);
  }
  
  async loadTrailerThumbnails() {
    for (const trailer of this.trailers) {
      try {
        const url = `${this.env}toqqer/static/post_videos/${trailer.file_Location}`;
        const match = trailer.file_Location.match(/SER_(\d+)_SEA_(\d+)/);
        const seasonId = match ? match[2] : null;
        const vidLibId = this.getSeason(seasonId);
        trailer.thumbnail = getVideoThumbnail(vidLibId);
        trailer.url = url;
      } catch (err) {
        trailer.thumbnail = '';
      }
    }
  }

  getSeason(seasonId: string) {
    if (this.seasons) {
      return (this.seasons.find(season => (season.seasonId) == seasonId)).episodes[0].tqrVideoBean.vidLibId;
    }
    return null;
  }

  openShareModal(video: any) {
    const host = window.location.hostname;
    const isDev = host.includes('dev.toqqer.com');
    const bPath = isDev ? 'cms' : 'cms-api';
    let videoLink = `${environment.baseUrl}${bPath}/s/${this.vidLibId}`;
    // let videoLink = `${environment.baseUrl}cms/s/${this.vidLibId}`;
    const params: string[] = [];
    if (this.whitelabelService.isWhiteLabel()) {
      const channel = (this.whitelabelService.channel || '').replace('@', '');
      const entry = this.whitelabelService.entryType || 'f';
      params.push(`c=${channel}`, `e=${entry}`);
    }
    const basePath = getAppBasePath();
    if (basePath) {
      params.push(`p=${encodeURIComponent(basePath)}`);
    }
    if (params.length) {
      videoLink += '?' + params.join('&');
    }
    if (navigator.share) {
      navigator.share({
        title: video?.title || 'Check out this video',
        url: videoLink
      }).catch(() => {});
    } else {
      this.dialog.open(ShareModalComponent, {
        data: { videoLink },
      });
    }
  }

  likeDislikeContent(status: string) {
    this.animateRate = true;
    this.categService.likeDislikeContent(this.vidLibId, this.userId, status)
      .subscribe({
        next: (result: any) => {
          if (this.isComponentDestroyed) return;
          this.getUserLikedVideos(this.vidLibId);
          this.animateRate = false;
        },
        error: (err) => {
          console.error('Failed to like/dislike content:', err);
          this.animateRate = false;
        }
      });
  }

  getUserLikedVideos(vidLibId: any): void {
    this.categService.getUserLikedVideos().subscribe({
      next: (result: any) => {
        if (this.isComponentDestroyed) return;
        this.isLiked = result.user_likes.includes(parseInt(vidLibId));
      },
      error: (err) => {
        console.error('Failed to fetch user liked videos:', err);
      }
    });
  }

  getStreamFile(videoOrId: any, suffix: string = '_drm_meta.mpd'): string {
    return getVideoStreamFile(videoOrId, suffix);
  }

  getResponsiveImageUrl(videoOrId: any, type: string): string {
    const isMobile = window.innerWidth <= 768;
    const suffix = isMobile ? '_thumb.jpg' : '_thumb_high.jpg';
    return this.buildImageUrl(videoOrId, type, suffix);
  }

  private buildImageUrl(videoOrId: any, type: string, suffix: string): string {
    if (type === 'movie') {
      return getVideoThumbnail(videoOrId, suffix);
    }
    const id = (typeof videoOrId === 'object' && videoOrId !== null) ? videoOrId?.series_id : videoOrId;
    return `${this.imgUrl}SER_${id}${suffix}`;
  }

  onHeroImageError(event: Event, videoOrId: any, type: string) {
    const img = event.target as HTMLImageElement;
    if (img.dataset['fallback'] === '1') {
      console.warn("⚠ All image variants failed → using placeholder");
      return;
    }
    img.dataset['fallback'] = '1';
    img.src = this.buildImageUrl(videoOrId, type, '_thumb_b.jpg');
  }

  removeDuplicates(data) {
    const tempObj = {};
    const finalResult = [];
    for(const ele of data) {
      if(!tempObj[ele.vidLibId]){
        finalResult.push(ele);
        tempObj[ele.vidLibId] = ele.vidLibId;
      }
    }
    return finalResult;
  }

  castSearch(member){
    console.log(member);
    if(member.roleType === 'cast'){
      const route = this.whitelabelService.getPrefixedRoute('browse', 'starring', member.roleType, member.originalName);
      console.log(route);
      this.router.navigate([route]);
    }else{
      const route = this.whitelabelService.getPrefixedRoute('browse', 'starring', member.roleType, member.name);
      console.log(route);
      this.router.navigate([route]);
    }
  }

  get castList() {
    return this.cast?.filter(p => p.roleType === 'cast') || [];
  }
  
  get crewList() {
    return this.cast?.filter(p => p.roleType === 'crew') || [];
  }

  get languages() {
    return this.selectedItem?.languages;
  }

  get titleLanguageNames(): string[] {
    return getLanguageNames(this.selectedItem?.titleLanguages);
  }

  /** Series header shows originalLanguage as a raw code (e.g. "te"); map it to
   *  the full name the same way the movie path and the banner do. */
  get seriesLanguageName(): string {
    return getLanguageName(this.seriesData?.originalLanguage);
  }

  toggleSynopsis(): void {
    this.showFullSynopsis = !this.showFullSynopsis;
  }
  
  openPlayerView(video: any){
    if (this.isGuestUser) {
      this.showLoginPrompt('Login or Create a Free Account to start watching');
      return;
    }
    const win = window as any;
    if(win?.AndroidTV && typeof win.AndroidTV.openVideoPlayer === 'function') {
      console.log("you are in android tv");
      const videoLibrary = video?.tqrVideoBean?.series_id ? video.tqrVideoBean : video;
      const isHls = video?.external_source === 'true';
      const baseUrl = environment.flix_video;
      const videoObj = video?.tqrVideoBean || video;
      const videoUrl = isHls ? `${baseUrl}${video?.playback_path}` : `${baseUrl}${getVideoStreamFile(videoObj)}`;
      // const videoUrl = isHls ? `${environment.flix_video}${video?.playback_path}` : `${environment.flix_video}VID_${video?.vidLibId}_drm_meta.mpd`;
      const requestBody = {
        videoUrl: videoUrl,
        drmLicenseUrl: this.axinomService.getWidevineUrl(),
        authToken: this.axinomService.getWidevineToken(),
        videoLibrary
      }
      console.log('vids json object →', requestBody);
      console.log('vids json string →', JSON.stringify(requestBody));
      win?.AndroidTV?.openVideoPlayer(JSON.stringify(requestBody));
      console.log('vids json', JSON.stringify(requestBody));
      return;
    }
    let route;
    if(video?.tqrVideoBean?.series_id){
      route = this.whitelabelService.getPrefixedRoute('shows', video.tqrVideoBean.series_id, this.seriesData.title, video.tqrVideoBean.vidLibId, 'watch');
    }else{
      route = this.whitelabelService.getPrefixedRoute('movies', video.title, video.vidLibId, 'watch');
    }
    if (this.bridgeService.isIOS()) {
      console.log("you are insdie the ios");
      const url = `${this.bridgeService.getCurrentDomain()}${route}?aspect=${video?.tqrVideoBean?.mediaLayout}`;
      const payload = {
        video: video?.tqrVideoBean?.series_id ? video?.tqrVideoBean : video,
        returnRoute: this.router.url,
        playerUrl: url ? url : `https://dev.toqqer.com/toqqer/static/toqqer-ui/${route}?aspect=${video?.tqrVideoBean?.mediaLayout}`,
      };
      this.bridgeService.openVideoPlayer(payload);
      return;
    }
    console.log("you areoutside the android tv or ios");
    if(video?.tqrVideoBean?.series_id){
      const route = this.whitelabelService.getPrefixedRoute('shows', video.tqrVideoBean.series_id, this.seriesData.title, video.tqrVideoBean.vidLibId, 'watch');
      console.log(route);
      if (video?.tqrVideoBean?.mediaLayout) {
        this.router.navigate([route], { 
          queryParams: { aspect: video?.tqrVideoBean?.mediaLayout } 
        });
      } else {
        this.router.navigate([route]);
      }      
    }else{
      const route = this.whitelabelService.getPrefixedRoute('movies', video.title, video.vidLibId, 'watch');
      this.router.navigate([route], {
        queryParams: { offlineUri: video?.offlineUri }
      });
    }
  }

  private showLoginPrompt(message: string): void {
    this.dialog.open(LoginPromptComponent, {
      panelClass: 'login-prompt-dialog',
      data: { message },
      disableClose: this.isTV
    });
  }

  get isGuestUser(): boolean {
    return this.authService.isGuest();
  }

  showPlansModal(hoveredMovie: any) {
    if (this.tvPurchaseRedirect.maybeShowSubscribe(hoveredMovie?.title)) return;
    const route = this.whitelabelService.getPrefixedRoute('channelplans');
    this.router.navigate([route], {
      queryParams: {
        channelId: hoveredMovie?.channelId,
        channelName: hoveredMovie?.channel_desc,
        vidLibId: hoveredMovie?.vidLibId
      }
    })
  }
  
  openPayments(hoveredMovie: any) {
    if (this.tvPurchaseRedirect.maybeShowRent(hoveredMovie?.title)) return;
    const route = this.whitelabelService.getPrefixedRoute('payment');
    console.log(hoveredMovie);
    this.router.navigate([route], {
      queryParams: {
        type: 'ppv',
        vidLibId: hoveredMovie?.vidLibId,
        movie: hoveredMovie?.title,
        durId: '2',
        planAmount: hoveredMovie.isChannelSubscribed ? hoveredMovie?.ppv_subscribed : hoveredMovie?.ppv_unsubscribed,
        durationName: hoveredMovie?.ppv_valid_for + ' days',
        currency: hoveredMovie.currencyCode,
        currencySymbol: hoveredMovie.currencySymbol
      }
    });
  } 

  imageError = false;
  onImageError(event: Event) {
    this.imageError = true;
  }

  onCastImgError(event: Event) {
    (event.target as HTMLImageElement).src = './assets/img/profile_avatar.png';
  }

  goBack(){
    window.history.back();
  }  

  async measureNetworkSpeed() {
    const testUrl = "https://dev.toqqer.com/toqqer/static/test-1mb.bin";
    const start = performance.now();
    const resp = await fetch(testUrl);
    const buffer = await resp.arrayBuffer();
    const duration = (performance.now() - start) / 1000;
    const speedMbps = ((buffer.byteLength * 8) / 1024 / 1024 / duration).toFixed(2);
    return Number(speedMbps);  
  }

  onBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.navigate(['/']);
    }
  }

  scrollTo(sectionId: string) {
    // On TV: switch tab content inline instead of scrolling
    if (this.device.isTV()) {
      this.switchTab(sectionId);
      return;
    }
    const el = document.getElementById(sectionId);
    if (!el) return;
    const yOffset = -80;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  switchTab(sectionId: string): void {
    const tabMap: any = {
      'season': 'seasons',
      'moreLike': 'morelikethis',
      'details': 'details',
      'trailer': 'trailers'
    };
    // Unregister content regions before switching (DOM will be destroyed by *ngIf)
    if (this.isTV) {
      this.componentRoute = this.router.url;
      this.tvNav.unregisterRegion(this.SEASONS_REGION_ID);
      this.tvNav.unregisterRegion(this.EPISODES_REGION_ID);
      this.tvNav.unregisterRegion(this.CAST_REGION_ID);
      this.tvNav.unregisterRegion(this.TRAILERS_REGION_ID);
    }
    this.activeLowerTab = tabMap[sectionId] || sectionId;
    this.cdr.detectChanges();
    // Re-register after new content renders
    if (this.isTV) {
      setTimeout(() => {
        this.registerDetailsRegions();
      }, 200);
    }
  }

  /**
   * Auto-switch tab content when a tab button receives focus (Hotstar-style).
   * Content changes on Left/Right navigation without pressing Enter.
   */
  private handleTabFocusSwitch(focusKey: string | null): void {
    if (!focusKey || !focusKey.startsWith(this.TABS_REGION_ID + ':')) return;
    const idx = parseInt(focusKey.split(':')[1], 10);
    const tabButtons = this.tabButtons?.toArray();
    if (!tabButtons || !tabButtons[idx]) return;

    // Map tab index to section ID based on which tabs are visible
    const visibleTabs: string[] = [];
    if (this.series_id) visibleTabs.push('season');
    if (this.moreLikeThis?.length) visibleTabs.push('moreLike');
    if (this.cast?.length) visibleTabs.push('details');
    if (this.trailers?.length) visibleTabs.push('trailer');

    const sectionId = visibleTabs[idx];
    if (sectionId) {
      this.switchTab(sectionId);
    }
  }

  /**
   * Handle scroll behavior on TV:
   * - Focus moves to tabs or below → scroll hero away, tabs at top
   * - Focus moves to actions (hero) → scroll back to top, hero visible
   */
  private handleTvScroll(focusKey: string | null): void {
    if (!focusKey) return;

    let currentZone: 'hero' | 'content' | null = null;
    if (focusKey.startsWith(this.ACTIONS_REGION_ID + ':')) {
      currentZone = 'hero';
    } else if (
      focusKey.startsWith(this.TABS_REGION_ID + ':') ||
      focusKey.startsWith(this.SEASONS_REGION_ID + ':') ||
      focusKey.startsWith(this.EPISODES_REGION_ID + ':') ||
      focusKey.startsWith(this.CAST_REGION_ID + ':') ||
      focusKey.startsWith(this.TRAILERS_REGION_ID + ':')
    ) {
      currentZone = 'content';
    }

    // Only scroll on hero ↔ content zone transitions. Intra-zone focus changes
    // (tab-to-tab) don't trigger any scroll — CSS `position: sticky` on the
    // tabs container handles pinning natively, regardless of *ngIf content
    // height changes. This eliminates the slide-up animation on tab swaps.
    if (currentZone === null || currentZone === this.lastScrollZone) return;

    if (currentZone === 'hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const heroSection = document.querySelector('.hero-section') as HTMLElement;
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        window.scrollTo({ top: heroBottom, behavior: 'smooth' });
      }
    }

    this.lastScrollZone = currentZone;
  }

  refreshSubscriptionsOnly() {
    this.walletService.getUserSubscriptions().subscribe(subscriptions => {
      if (!subscriptions || !this.selectedItem) return;
      this.selectedItem.isChannelSubscribed = false;
      this.selectedItem.isPPVSubscribed = false;
      subscriptions.forEach((sitem: any) => {
        if (this.selectedItem.channelId == sitem.channelId && sitem.isActive) {
          this.selectedItem.isChannelSubscribed = true;
          this.selectedItem.expiringDate = sitem.dateOfExpiry;
        }
        if (
          (this.selectedItem.vidLibId == sitem.vidLibId ||
           this.selectedItem.vidLibId == sitem.contentId) &&
          sitem.isActive
        ) {
          this.selectedItem.isPPVSubscribed = true;
          this.selectedItem.expiringDate = sitem.dateOfExpiry;
        }
      });
      this.cdr.detectChanges();
    });
  }
}


@Component({
  selector: 'app-download-quality-dialog',
  templateUrl: './download-quality-dialog.component.html',
  styleUrls: ['./video-details.component.css']
})
export class DownloadQualityDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadQualityDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { qualities: any[] }
  ) {
    console.log(this.data);
  }
  selectedRes:any = null;

  select(q: any) {
    this.selectedRes = q
  }

  submit(){
    if(this.selectedRes)
    this.dialogRef.close(this.selectedRes);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}